import React, { useCallback, useEffect, useMemo } from "react";
import { CallingTheme, StreamMedia, useTheme, VideoGalleryLocalParticipant, VideoStreamOptions, VideoTile } from "@azure/communication-react";
import { useCallAdapter } from "../../provider";
import { getLocalPreviewTileStyle } from "../../styles/LocalPreview.styles";
import { VideoTileIndicatorsOverlay } from "./VideoTileIndicatorsOverlay";
import { videoTileStyle } from "../../styles/VideoTile.styles";
import { concatStyleSets, Theme } from "@fluentui/react";

export interface ModeratorLocalPreviewTileProps {
    localParticipant: VideoGalleryLocalParticipant;
    scalingMode?: 'Crop'|'Fit'
}

export const LocalPreviewTile = (props: ModeratorLocalPreviewTileProps): JSX.Element => {
    const { localParticipant, scalingMode = 'Fit' } = props;

    const adapter = useCallAdapter();
    const themeV8 = useTheme() as Theme & CallingTheme;   //using value of "FluentThemeProvider" component
    const createLocalStreamView = useCallback(
        (options?: VideoStreamOptions) => adapter.createStreamView(undefined, options)
        , [adapter]
    );

    useEffect(() => {
        createLocalStreamView({ scalingMode });
    }, [localParticipant.videoStream]);

    const localVideoTileStyle = useMemo(() => concatStyleSets(
        getLocalPreviewTileStyle(scalingMode),
        videoTileStyle(themeV8, !!localParticipant.raisedHand)
    ), [scalingMode, themeV8, localParticipant.raisedHand]);
    return (
        <VideoTile
            styles={localVideoTileStyle}
            renderElement={
                // localPreviewProps?.videoStreamElement ? (
                localParticipant.videoStream?.renderElement ? (
                    <StreamMedia videoStreamElement={localParticipant.videoStream.renderElement} />
                ) : undefined
            }
            // onRenderPlaceholder={onRenderPlaceholder}
            showLabel={true}
            displayName="Du"
        >
            <VideoTileIndicatorsOverlay isMuted={localParticipant.isMuted} raisedHand={localParticipant.raisedHand} />
        </VideoTile>
    );
};
